import { InnerTabs, MyBreadcrumb, MyButton, MyModalForm, MyText } from "../../../../components";
import {
  Badge,
  Card, Checkbox,
  Col,
  Collapse,
  Form, List, Modal,
  Popconfirm,
  Row,
  Spin,
  TabsProps
} from "antd";
import { StyledInfoContainer } from "../index.styles";
import { createSearchParams, generatePath, Link, useNavigate, useParams, useSearchParams } from "react-router-dom";
import {
  COMPONENT_TYPES_ENUM,
  FORM_SECTION_TYPES,
  FORM_SECTION_INNER_TYPE,
  JOURNAL_QUERY_PARAMS,
  PLANS_API,
  FORM_FORM_TYPE, PLANS_TYPES,
  ROUTE_PATH,
  DATE_FORMAT
} from "../../../../constants";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  addOneLessonAction,
  deleteOneLessonAction,
  deleteTabInnerContentAction,
  editLessonAction, getExamStatementAction,
  getLessonAction,
  getOneCtpAction,
  getOneLessonAction, getOneTaskAction, getQuestionAnswerAction,
  getQuestionAnswerActionFail, setStudentListAction,
  testImportFromLibrary,
  testImportFromLibraryDone, testsImportAction,
  updateTabInnerContentAction,
} from "../../../../store/pages/plans/actions";
import { getFormAction, getFormActionReset, setFormAction } from "../../../../store/common/actions";
import { selectStore } from "../../../../store/selector";
import { RootState } from "../../../../store";
import dayjs from "dayjs";
import { DeleteOutlined, EditOutlined, DownloadOutlined } from "@ant-design/icons";
import { StyledTabs } from "./index.styles";
import { useTranslation } from "react-i18next";
import { copyTestAction } from "../../../../store/pages/library/actions";

interface IInitialState {
  visible: boolean,
  item?: any, array: any[]
}

export const LessonView = () => {
  const { t } = useTranslation("common")

  const dispatch = useDispatch()

  const navigate = useNavigate();

  const { ctpId, lessonId } = useParams()

  const [formAdd] = Form.useForm()
  const [formEditPlan] = Form.useForm()
  const [formTabContent] = Form.useForm()
  const [formTestsImport] = Form.useForm()
  const [searchParams, setSearchParams] = useSearchParams();

  const FORM_NAME = {
    PLANS_TAB_ADD: 'PLANS_TAB_ADD',
    PLANS_TAB_UPDATE: 'PLANS_TAB_UPDATE',
    PLANS_LESSON_UPDATE: 'PLANS_LESSON_UPDATE',
    PLANS_TESTS_IMPORT: 'PLANS_TESTS_IMPORT',
    PLANS_TESTS_IMPORT_FROM_LIBRARY: 'PLANS_TESTS_IMPORT_FROM_LIBRARY',
    PLANS_TESTS_USER_LIST: 'PLANS_TESTS_USER_LIST',
  }

  const initialState: IInitialState = {
    visible: false,
    item: {},
    array: []
  }

  const modalInitialState = {
    [FORM_NAME.PLANS_TAB_ADD]: initialState,
    [FORM_NAME.PLANS_TAB_UPDATE]: initialState,
    [FORM_NAME.PLANS_LESSON_UPDATE]: initialState,
    [FORM_NAME.PLANS_TESTS_IMPORT]: initialState,
    [FORM_NAME.PLANS_TESTS_IMPORT_FROM_LIBRARY]: initialState,
    [FORM_NAME.PLANS_TESTS_USER_LIST]: initialState,
  }

  const selectedTab = searchParams.get('selectedTab') ? searchParams.get('selectedTab') : FORM_FORM_TYPE.MATERIALS;

  const [currentTab, setCurrentTab] = useState(selectedTab ? selectedTab : FORM_FORM_TYPE.MATERIALS)

  const [formModalData, setFormModalData] = useState(modalInitialState)

  const [extraFieldsArr, setExtraFieldsArr] = useState([])
  useEffect(() => {
    dispatch(getOneLessonAction({
      lesson_id: lessonId,
    }))
    dispatch(getOneCtpAction(ctpId))
  }, []);

  const {
    common: { ctp: ctpState, form: formState },
    plans: {
      oneLesson: oneLessonState,
      oneCtp: oneCtpState,
      testImportFromLibrary: testImportFromLibraryState,
      oneTest: oneTestState,
      oneTask: oneTaskState
    }
  }: RootState = useSelector(selectStore)

  useEffect(() => {
    if (formTabContent.getFieldsValue().is_difficulty == 1) {
      modalChangeValues({ is_difficulty: 1 }, {}, FORM_SECTION_INNER_TYPE.UPDATE)
    }
  }, [formState[FORM_SECTION_TYPES.PLANS]?.[currentTab]?.[FORM_SECTION_INNER_TYPE.UPDATE]])
  useEffect(() => {
    if (oneTestState.data || oneTaskState.data) {
      let values = (oneTestState.data || oneTaskState.data)?.student_list?.filter((item: any) => item.checked).map((item: any) => (item.id))

      setFormModalData(prevState => ({
        ...prevState,
        [FORM_NAME.PLANS_TESTS_USER_LIST]: {
          ...prevState[FORM_NAME.PLANS_TESTS_USER_LIST],
          array: values
        }
      }))
    }
  }, [oneTestState.data, oneTaskState.data])

  const handleDeleteLesson = () => {
    dispatch(deleteOneLessonAction({ lesson_id: lessonId }))

    navigate(-1)
  }

  const setUrlParams = (body: any) => {
    setSearchParams(body, { replace: true })
  }
  const handleAddPlan = () => {
    setFormModalData(prevState => ({
      ...prevState,
      [FORM_NAME.PLANS_TAB_ADD]: { ...prevState[FORM_NAME.PLANS_TAB_ADD], visible: true }
    }))

    let apiUrl = PLANS_API[`${FORM_SECTION_INNER_TYPE.ADD}_${currentTab}`]

    dispatch(getFormAction({
      api: apiUrl,
      section_type: FORM_SECTION_TYPES.PLANS,
      section_inner_type: currentTab,
      form_type: FORM_SECTION_INNER_TYPE.ADD
    }))
  }

  const handleAddTestFromLibrary = () => {
    dispatch(testImportFromLibrary({ type: currentTab, params: { ctp_id: ctpId } }))

    setFormModalData(prevState => ({
      ...prevState,
      [FORM_NAME.PLANS_TESTS_IMPORT_FROM_LIBRARY]: {
        ...prevState[FORM_NAME.PLANS_TESTS_IMPORT_FROM_LIBRARY],
        visible: true
      }
    }))
  }

  const handleChangeTabTestFromLibrary = (key: string) => {
    dispatch(testImportFromLibrary({
      type: currentTab, params: {
        ctp_id: ctpId,
        ...(key === PLANS_TYPES.PUBLIC ? { is_shared: 1 } : {}),
      }
    }))
  }

  const handleClickButtonViewTestFromLibrary = (id: number) => {
    handleNavigate(ROUTE_PATH.LESSON_TEST_VIEW, id)
  }

  const handleSelectTestFromLibrary = (id: number) => {
    setFormModalData(prevState => {
      return {
        ...prevState,
        [FORM_NAME.PLANS_TESTS_IMPORT_FROM_LIBRARY]: {
          ...prevState[FORM_NAME.PLANS_TESTS_IMPORT_FROM_LIBRARY],
          item: {
            id: prevState[FORM_NAME.PLANS_TESTS_IMPORT_FROM_LIBRARY]?.item?.id === id ? null : id
          }
        }
      }
    })
  }

  const handleOkTestImportFromLibrary = () => {
    let url = {
      [FORM_FORM_TYPE.MATERIALS]: '/edu/copy-material',
      [FORM_FORM_TYPE.TASKS]: '/edu/copy-task',
      [FORM_FORM_TYPE.TESTS]: '/edu/copy-test',
    }

    let current = {
      [FORM_FORM_TYPE.MATERIALS]: 'material_id',
      [FORM_FORM_TYPE.TASKS]: 'task_id',
      [FORM_FORM_TYPE.TESTS]: 'test_id',
    }

    let body = {
      [current[currentTab]]: formModalData[FORM_NAME.PLANS_TESTS_IMPORT_FROM_LIBRARY]?.item?.id,
      to_ctp_id: ctpId,
      to_lesson_id: lessonId
    }


    dispatch(setFormAction({
      method: 'post',
      path: url[currentTab],
      fields: body,
      action: copyTestAction
    }))

    handleFormModalClose()
  }

  const tabContentTestFromLibrary = () => {
    let content = (
      <List
        loading={testImportFromLibraryState.loading}
        dataSource={testImportFromLibraryState.data || []}
        rowKey={(record: any) => record.id}
        style={{ maxHeight: 500, overflowY: 'scroll' }}
        renderItem={(listItem: any) => {
          return (
            <List.Item onClick={() => handleSelectTestFromLibrary(listItem.id)} style={{ padding: 6 }}>
              <div style={{
                padding: 10,
                borderWidth: 2,
                borderRadius: 8,
                width: '100%',
                borderStyle: 'solid',
                borderColor: formModalData[FORM_NAME.PLANS_TESTS_IMPORT_FROM_LIBRARY]?.item?.id == listItem.id ? 'var(--c-primary)' : 'transparent'
              }}>
                <Row gutter={[8, 8]}>
                  <Col span={24}>
                    <Row gutter={[8, 8]}>
                      {
                        listItem?.data?.map((item: any) => (
                          <Col key={item.label} span={24}>
                            <Row gutter={[8, 8]} align='middle'>
                              <Col span={10}>
                                <MyText>
                                  {item.label}:
                                </MyText>
                              </Col>

                              <Col flex={1}>
                                <MyText>
                                  {item.value}
                                </MyText>
                              </Col>
                            </Row>
                          </Col>
                        ))
                      }
                    </Row>
                  </Col>

                  {
                    currentTab === FORM_FORM_TYPE.TESTS &&
                    <Col>
                      <MyButton onClick={() => handleClickButtonViewTestFromLibrary(listItem.id)}>
                        {t('QAViewTest')}
                      </MyButton>
                    </Col>
                  }

                </Row>
              </div>
            </List.Item>
          )
        }}
      />
    )
    return [
      {
        key: PLANS_TYPES.PRIVATE,
        label: t('private'),
        children: content
      },
      {
        key: PLANS_TYPES.PUBLIC,
        label: t('public'),
        children: content
      }
    ]
  }

  const handleOkTestUserList = () => {
    let current = {
      [FORM_FORM_TYPE.MATERIALS]: 'material',
      [FORM_FORM_TYPE.TASKS]: 'task',
      [FORM_FORM_TYPE.TESTS]: 'test',
    }

    let body = {
      students: formModalData[FORM_NAME.PLANS_TESTS_USER_LIST].array
    }
    dispatch(setFormAction({
      method: 'put',
      path: `sdot/${current[currentTab]}/${formModalData[FORM_NAME.PLANS_TESTS_USER_LIST].item?.id}`,
      fields: body,
      action: setStudentListAction
    }))

    handleFormModalClose()
  }

  const handleTestUserList = (item: any) => {
    setFormModalData(prevState => ({
      ...prevState,
      [FORM_NAME.PLANS_TESTS_USER_LIST]: { ...prevState[FORM_NAME.PLANS_TESTS_USER_LIST], visible: true, item: item }
    }))

    if (currentTab === FORM_FORM_TYPE.TASKS) {
      dispatch(getOneTaskAction(item.id))
    }

    if (currentTab === FORM_FORM_TYPE.TESTS) {
      dispatch(getQuestionAnswerAction(item.id))
    }
  }

  const testUserListContent = useMemo(() => {
    return (
      <Spin spinning={oneTestState.loading}>
        <Checkbox.Group value={formModalData[FORM_NAME.PLANS_TESTS_USER_LIST]?.array} onChange={values => {
          setFormModalData(prevState => ({
            ...prevState,
            [FORM_NAME.PLANS_TESTS_USER_LIST]: {
              ...prevState[FORM_NAME.PLANS_TESTS_USER_LIST],
              array: values
            }
          }))
        }}>
          <Row gutter={[16, 16]}>
            {(oneTestState.data || oneTaskState.data)?.student_list?.map((item: any) => (
              <Col key={item.id} span={24}>
                <Checkbox value={item.id}>
                  {item.full_name}
                </Checkbox>
              </Col>
            ))}
          </Row>
        </Checkbox.Group>
      </Spin>
    )
  }, [oneTestState, formModalData[FORM_NAME.PLANS_TESTS_USER_LIST]])

  const handleEditPlan = () => {
    setFormModalData(prevState => ({
      ...prevState,
      [FORM_NAME.PLANS_LESSON_UPDATE]: { ...prevState[FORM_NAME.PLANS_LESSON_UPDATE], visible: true }
    }))


    let apiUrl = PLANS_API[`${FORM_SECTION_INNER_TYPE.UPDATE}_${FORM_FORM_TYPE.PLAN}`]

    dispatch(getFormAction({
      api: apiUrl,
      section_type: FORM_SECTION_TYPES.PLANS,
      section_inner_type: FORM_FORM_TYPE.LESSON,
      form_type: FORM_SECTION_INNER_TYPE.UPDATE,
    }))

    formEditPlan.setFields(oneLessonState.data?.view?.map((item: any) => ({
      name: item.name,
      value: item.value,
    })))
  }

  const handleFormModalTabAddOk = (values: any) => {
    const main: any = formState[FORM_SECTION_TYPES.PLANS][currentTab][FORM_SECTION_INNER_TYPE.ADD].data[0]

    let body = {
      ...values,
      lesson_id: lessonId,
      currentTab: currentTab,
      ...(values.is_shared ? { is_shared: true } : { is_shared: false }),
      ...(values.draft ? { draft: true } : { draft: false }),

      //todo смотреть тут, если ошибка на бэке на каждый field
      form: formAdd,
      handleClose: () => handleFormModalClose()
    }

    dispatch(setFormAction({
      method: main?.method,
      path: main?.action,
      fields: body,
      action: addOneLessonAction
    }))
  }

  const handleFormUpdatePlanModalOk = (values: any) => {
    const main: any = formState[FORM_SECTION_TYPES.PLANS][FORM_FORM_TYPE.LESSON][FORM_SECTION_INNER_TYPE.UPDATE].data[0]

    let body = {
      ...values,
      lesson_id: lessonId,
      date_at: dayjs(values.date_at).format('YYYY-MM-DD hh:mm:ss'),
    }

    dispatch(setFormAction({
      method: main?.method,
      path: `${main?.action}/${lessonId}`,
      fields: body,
      action: editLessonAction
    }))

    handleFormModalClose()
  }

  const handleFormModalTabUpdateOk = (values: any) => {
    const main: any = formState[FORM_SECTION_TYPES.PLANS][currentTab][FORM_SECTION_INNER_TYPE.UPDATE].data[0]

    let body = {
      ...values,
      id: formModalData[FORM_NAME.PLANS_TAB_UPDATE]?.item?.id,
      lesson_id: lessonId,
      currentTab: currentTab,
      form: formTabContent,
      handleClose: () => handleFormModalClose()
    }

    dispatch(setFormAction({
      method: main?.method,
      path: `${main?.action}/${formModalData[FORM_NAME.PLANS_TAB_UPDATE]?.item?.id}`,
      fields: body,
      action: updateTabInnerContentAction
    }))

    handleFormModalClose()
  }

  const handleFormTestsImportModalOk = (values: any) => {
    const main: any = formState[FORM_SECTION_TYPES.PLANS][FORM_FORM_TYPE.TESTS][FORM_SECTION_INNER_TYPE.IMPORT].data[0]

    let body = {
      ...values,
      test_id: formModalData[FORM_NAME.PLANS_TESTS_IMPORT]?.item?.id,
      file: values.file[0],
      lesson_id: lessonId,
    }

    dispatch(setFormAction({
      method: main?.method,
      path: main?.action,
      fields: body,
      action: testsImportAction
    }))

    handleFormModalClose()
  }

  const handleFormModalClose = () => {
    setFormModalData(modalInitialState)
    dispatch(getFormActionReset())
    setExtraFieldsArr([])
    formAdd.resetFields()
    formEditPlan.resetFields()
    formTabContent.resetFields()
    formTestsImport.resetFields()
    // @ts-ignore
    dispatch(testImportFromLibraryDone([]))
    dispatch(getQuestionAnswerActionFail())
  }

  const handleNavigate = (url: any, id: any) => {
    const path = {
      // @ts-ignore
      pathname: generatePath(url, { lessonId: lessonId, ctpId: ctpId, testId: id }),
    }

    navigate(path, { state: id });
  }

  const renderInnerItem = (item: any) => {
    return (
      <Row align='middle' gutter={6}>
        <Col span={7}>
          <MyText color={'var(--c-subtitle)'} weight={500}>
            {item.label}:
          </MyText>
        </Col>

        <Col span={17}>
          <MyText>
            <div dangerouslySetInnerHTML={{ __html: item?.value }} />
          </MyText>
        </Col>
      </Row>
    )
  }

  const handleImportTest = (item: any) => {
    setFormModalData(prevState => ({
      ...prevState,
      [FORM_NAME.PLANS_TESTS_IMPORT]: { ...prevState[FORM_NAME.PLANS_TESTS_IMPORT], visible: true, item: item }
    }))


    let apiUrl = PLANS_API[`${FORM_SECTION_INNER_TYPE.IMPORT}_${FORM_FORM_TYPE.TESTS}`]

    dispatch(getFormAction({
      api: apiUrl,
      section_type: FORM_SECTION_TYPES.PLANS,
      section_inner_type: FORM_FORM_TYPE.TESTS,
      form_type: FORM_SECTION_INNER_TYPE.IMPORT
    }))
  }

  const handleDownloadExamStatement = () => {
    dispatch(getExamStatementAction(oneLessonState.data.id))
  }

  const handleRenderDownloadStatement = () => {
    switch (oneLessonState?.data?.column_type) {
      case 15:
      case 16:
      case 20:
      case 28:
      case 33:
      case 34:
      case 39:
        return (
          <Col>
            <MyButton ghost
              type="primary"
              title={t("downloadExamStatement")}
              icon={<DownloadOutlined />}
              onClick={() => handleDownloadExamStatement()} />
          </Col>
        )
    }
  }

  const innerRenderCurrentTab = useCallback((item: any) => {
    switch (currentTab) {
      case FORM_FORM_TYPE.MATERIALS:
        return (
          <Row gutter={[16, 16]}>
            {
              item?.view?.map((inner: any, index: any) => (
                <Col key={index} span={24}>
                  {renderInnerItem(inner)}
                </Col>
              ))
            }
            <Col span={24}>
              <Row gutter={16}>
                {
                  item?.isEdit &&
                  <Col>
                    <MyButton title={t('edit')} warning type='default' icon={<EditOutlined />}
                      onClick={() => handleEditTabInnerContent(item)} />
                  </Col>
                }

                {
                  item?.isDelete &&
                  <Col>
                    <Popconfirm
                      title={t('planDeleteTitle')}
                      description={t('planDeleteDescription')}
                      onConfirm={(e) => handleDeleteInnerTabContent(e, item)}
                      okText={t('yes')}
                      cancelText={t('no')}
                    >
                      <MyButton danger type='default' icon={<DeleteOutlined />}>Удалить</MyButton>
                    </Popconfirm>
                  </Col>
                }

              </Row>
            </Col>
          </Row>
        )
      case FORM_FORM_TYPE.TASKS:
        return (
          <Row gutter={[16, 16]}>
            {
              item?.view?.map((inner: any, index: any) => (
                <Col key={index} span={24}>
                  <Col key={index} span={24}>
                    {renderInnerItem(inner)}
                  </Col>
                </Col>
              ))
            }
            <Col span={24}>
              <Row gutter={16}>
                {
                  item?.isEdit &&
                  <Col>
                    <MyButton title={t('edit')} warning type='default' icon={<EditOutlined />}
                      onClick={() => handleEditTabInnerContent(item)} />
                  </Col>
                }

                {
                  item?.isDelete &&
                  <Col>
                    <Popconfirm
                      title={t('planDeleteTitle')}
                      description={t('planDeleteDescription')}
                      onConfirm={(e) => handleDeleteInnerTabContent(e, item)}
                      okText={t('yes')}
                      cancelText={t('no')}
                    >
                      <MyButton danger type='default' icon={<DeleteOutlined />}>Удалить</MyButton>
                    </Popconfirm>
                  </Col>
                }

                {
                  item?.isEdit &&
                  <Col>
                    <MyButton title={t('testUserList')}
                      height={40}
                      type="text"
                      onClick={() => handleTestUserList(item)}
                    />
                  </Col>
                }

              </Row>
            </Col>
          </Row>
        )
      case FORM_FORM_TYPE.TESTS:
        return (
          <Row gutter={[16, 16]}>
            {
              item?.view?.map((inner: any, index: any) => (
                <Col key={index} span={24}>
                  <Col key={index} span={24}>
                    {renderInnerItem(inner)}
                  </Col>
                </Col>
              ))
            }
            <Col span={24}>
              <Row gutter={16}>
                {
                  item?.isEdit &&
                  <Col>
                    <MyButton title={t('edit')} warning type='default' icon={<EditOutlined />}
                      onClick={() => handleEditTabInnerContent(item)} />
                  </Col>
                }
                {
                  item?.isDelete &&
                  <Col>
                    <Popconfirm
                      title={t('planDeleteTitle')}
                      description={t('planDeleteDescription')}
                      onConfirm={(e) => handleDeleteInnerTabContent(e, item)}
                      okText={t('yes')}
                      cancelText={t('no')}
                    >
                      <MyButton danger type='default' icon={<DeleteOutlined />}>
                        {t('delete')}
                      </MyButton>
                    </Popconfirm>
                  </Col>
                }
                {
                  handleRenderDownloadStatement()
                }

              </Row>
            </Col>

            <Col span={24}>
              <Row justify="space-between">
                <Row style={{ gap: 16 }}>
                  {
                    item?.isEdit &&
                    <Col>
                      <MyButton ghost height={40}
                        type="primary"
                        onClick={() => handleNavigate(ROUTE_PATH.LESSON_TEST, item.id)}>
                        {item?.questions?.length > 0 ? t('QAEditTest') : t('QAAddTest')}
                      </MyButton>
                    </Col>
                  }

                  {
                    (item?.isEdit && item?.questions?.length > 0) &&
                    <Col>
                      <MyButton ghost height={40}
                        type="primary"
                        onClick={() => handleNavigate(ROUTE_PATH.LESSON_TEST_VIEW, item.id)}>
                        {t('QAViewTest')}
                      </MyButton>
                    </Col>
                  }
                  {
                    item?.isEdit &&
                    <Col>
                      <MyButton title={t('importTest')}
                        ghost height={40}
                        type="primary"
                        onClick={() => handleImportTest(item)}
                      />
                    </Col>
                  }
                  {
                    item?.isEdit &&
                    <Col>
                      <MyButton title={t('testUserList')}
                        height={40}
                        type="text"
                        onClick={() => handleTestUserList(item)}
                      />
                    </Col>
                  }

                </Row>
              </Row>

            </Col>
          </Row>
        )

      default:
        return false

    }
  }, [currentTab])

  const handleEditTabInnerContent = (item: any) => {
    setFormModalData(prevState => ({
      ...prevState,
      [FORM_NAME.PLANS_TAB_UPDATE]: { ...prevState[FORM_NAME.PLANS_TAB_UPDATE], visible: true, item: item }
    }))

    let apiUrl = item?.formEdit

    if (apiUrl) {
      dispatch(getFormAction({
        api: apiUrl,
        section_type: FORM_SECTION_TYPES.PLANS,
        section_inner_type: currentTab,
        form_type: FORM_SECTION_INNER_TYPE.UPDATE
      }))
    }
    formTabContent.setFieldsValue({
      ...item,
      start_date: item.start_date ? dayjs(item.start_date) : null,
      end_date: item.end_date ? dayjs(item.end_date) : null,
    })
  }

  const handleDeleteInnerTabContent = (e: any, item: any) => {
    let current = {
      [FORM_FORM_TYPE.MATERIALS]: 'material',
      [FORM_FORM_TYPE.TASKS]: 'task',
      [FORM_FORM_TYPE.TESTS]: 'test',
    }

    dispatch(setFormAction({
      method: 'delete',
      path: `/sdot/${current[currentTab]}/${item.id}`,
      fields: { ...item, currentTab },
      action: deleteTabInnerContentAction
    }))
  }

  const innerRender = useMemo(() => {
    const items = oneLessonState.data && oneLessonState.data[currentTab]?.map((item: any) => ({
      key: item.id,
      label: item.name,
      children: innerRenderCurrentTab(item),
      extra: (
        <Row gutter={16}>
          <Col>
            <Badge status={'success'} text={t('published')} />
          </Col>

          {
            item.updated_at &&
            <Col>
              <MyText>
                {dayjs(item.updated_at).format('DD.MM.YYYY HH:mm')}
              </MyText>
            </Col>
          }

        </Row>
      )
    }))

    return (
      <Card loading={oneLessonState.loading}>
        <Row gutter={[16, 32]}>
          {
            oneLessonState.data?.isEdit &&
            <Col span={24}>
              <Row gutter={[16, 16]}>
                <Col>
                  <MyButton type="primary" onClick={handleAddPlan}>{t('add')}</MyButton>
                </Col>
                <Col>
                  <MyButton type="primary" onClick={handleAddTestFromLibrary}>{t('addFromLibrary')}</MyButton>
                </Col>
              </Row>
            </Col>
          }

          <Col span={24}>
            <Collapse items={items} defaultActiveKey={['1']} />
          </Col>
        </Row>
      </Card>
    )
  }, [oneLessonState, currentTab])

  const tabItems: TabsProps["items"] = [
    {
      key: FORM_FORM_TYPE.MATERIALS,
      label: t('materials'),
      children: innerRender
    },
    {
      key: FORM_FORM_TYPE.TASKS,
      label: t('tasks'),
      children: innerRender
    },
    {
      key: FORM_FORM_TYPE.TESTS,
      label: t('tests'),
      children: innerRender
    },
  ]

  const handleTabChange = (key: any) => {
    setUrlParams({ selectedTab: key })
    setCurrentTab(key)
  }

  const collapseData = useMemo(() => {
    return oneLessonState.data?.view?.filter((item: any, index: any) => {
      if (item.template === 'accordion') {
        return {
          key: index,
          label: item.label,
          children: item.value
        }
      }
    }).map((item: any) => ({ ...item, children: item.value, className: item.value ? 'fulfilled' : 'empty' }))
  }, [oneLessonState.data])

  const headerListRender = useMemo(() =>
    oneLessonState.data?.view?.filter((item: any, index: any) => item.template !== 'accordion' && item.value).map((item: any) => (
      <Col key={item.label} span={12}>
        <MyText>
          {item.label}: {(item.label === 'Дата' || item.label === 'Күні') ? dayjs(item.value).format(DATE_FORMAT.FULL) : item.value}
        </MyText>
      </Col>
    )), [oneLessonState.data])

  const modalChangeValues = (changedFields: any, allFields: any, type: any) => {
    const fieldsArr = formState[FORM_SECTION_TYPES.PLANS][currentTab][type].data[0]?.fields
    let fieldName = Object.keys(changedFields)[0]
    let fieldValue = Object.values(changedFields)[0]
    let getObject = fieldsArr.find((fieldItem: any) => fieldItem.name === fieldName)
    let getExtraField = getObject?.fieldValues?.find((fieldItem: any) => fieldItem.value === fieldValue)

    switch (getObject?.type) {
      case COMPONENT_TYPES_ENUM.TYPE_SELECT:
        if (getExtraField?.fields) {
          setExtraFieldsArr(getExtraField?.fields)
        } else {
          setExtraFieldsArr([])
        }
        break

      default:
        break
    }
  }
  return (
    <>
      <MyBreadcrumb title={t('back')} isBack  extra={(
        <Row gutter={16}>
          {
            oneLessonState?.data?.isEdit &&
            <Col>
              <MyButton onClick={handleEditPlan}
                warning
                height={40}
                type="default"
                htmlType="submit"
                icon={<EditOutlined />}
                title={t('edit')} />
            </Col>
          }

          {
            oneLessonState?.data?.isDelete &&
            <Col>
              <Popconfirm
                placement="bottomRight"
                title={t('planDeleteTitle')}
                description={t('planDeleteDescription')}
                onConfirm={handleDeleteLesson}
                okText={t('yes')}
                cancelText={t('no')}
              >
                <MyButton danger type='primary' ghost
                  height={40}
                  icon={<DeleteOutlined />}
                  htmlType="submit"
                  title={t('delete')}
                />
              </Popconfirm>
            </Col>
          }
        </Row>
      )} />

      <Row justify='center'>
        <Col span={20}>
          <StyledInfoContainer>
            <Spin spinning={oneCtpState.loading}>
              <Row style={{ borderBottom: '1px solid #E8E8E8', padding: 24 }}>
                <Col>
                  <h1>{t('lessonsPlan')}</h1>
                </Col>
              </Row>
              <Row gutter={[16, 16]} style={{ padding: 24 }}>
                <Col span={12}>
                  <MyText>
                    {t('group')}: {oneCtpState.data?.group}
                  </MyText>
                </Col>

                <Col span={12}>
                  <MyText>
                    {t('module')}: {oneCtpState.data?.module}
                  </MyText>
                </Col>
                <Col span={12}>
                  <MyText>
                    {t('discipline')}: {oneCtpState.data?.subject}
                  </MyText>
                </Col>

                {headerListRender}
              </Row>
            </Spin>
          </StyledInfoContainer>

          {
            collapseData?.length > 0 &&
            <StyledInfoContainer>
              <Col style={{ padding: 24 }}>
                <Spin spinning={oneLessonState.loading}>
                  <Collapse
                    items={collapseData}
                  />
                </Spin>
              </Col>
            </StyledInfoContainer>
          }

          {oneLessonState.data?.isSdot ? (
            <StyledInfoContainer>
              <StyledTabs activeKey={currentTab} items={tabItems} onChange={handleTabChange} />
            </StyledInfoContainer>
          ) : null}
        </Col>
      </Row>

      <MyModalForm
        formName={FORM_NAME.PLANS_TAB_ADD}
        form={formAdd}
        title={formState[FORM_SECTION_TYPES.PLANS]?.[currentTab]?.[FORM_SECTION_INNER_TYPE.ADD]?.data[0]?.title}
        visible={formModalData[FORM_NAME.PLANS_TAB_ADD].visible}
        state={formState[FORM_SECTION_TYPES.PLANS]?.[currentTab]?.[FORM_SECTION_INNER_TYPE.ADD]}
        onCancel={handleFormModalClose}
        onFinish={handleFormModalTabAddOk}
        onValuesChange={(changedFields: any, allFields: any) => modalChangeValues(changedFields, allFields, FORM_SECTION_INNER_TYPE.ADD)}
        extraFieldsArr={extraFieldsArr}
      />

      <MyModalForm
        formName={FORM_NAME.PLANS_LESSON_UPDATE}
        form={formEditPlan}
        title={formState[FORM_SECTION_TYPES.PLANS]?.[FORM_FORM_TYPE.LESSON]?.[FORM_SECTION_INNER_TYPE.UPDATE]?.data[0]?.title}
        visible={formModalData[FORM_NAME.PLANS_LESSON_UPDATE].visible}
        state={formState[FORM_SECTION_TYPES.PLANS]?.[FORM_FORM_TYPE.LESSON]?.[FORM_SECTION_INNER_TYPE.UPDATE]}
        onCancel={handleFormModalClose}
        onFinish={handleFormUpdatePlanModalOk}
      />

      <MyModalForm
        formName={FORM_NAME.PLANS_TAB_UPDATE}
        form={formTabContent}
        title={formState[FORM_SECTION_TYPES.PLANS]?.[currentTab]?.[FORM_SECTION_INNER_TYPE.UPDATE]?.data[0]?.title}
        visible={formModalData[FORM_NAME.PLANS_TAB_UPDATE].visible}
        state={formState[FORM_SECTION_TYPES.PLANS]?.[currentTab]?.[FORM_SECTION_INNER_TYPE.UPDATE]}
        onCancel={handleFormModalClose}
        onFinish={handleFormModalTabUpdateOk}
        onValuesChange={(changedFields: any, allFields: any) => modalChangeValues(changedFields, allFields, FORM_SECTION_INNER_TYPE.UPDATE)}
        extraFieldsArr={extraFieldsArr}
      />

      <MyModalForm
        formName={FORM_NAME.PLANS_TESTS_IMPORT}
        form={formTestsImport}
        title={formState[FORM_SECTION_TYPES.PLANS]?.[FORM_FORM_TYPE.TESTS]?.[FORM_SECTION_INNER_TYPE.IMPORT]?.data[0]?.title}
        visible={formModalData[FORM_NAME.PLANS_TESTS_IMPORT].visible}
        state={formState[FORM_SECTION_TYPES.PLANS]?.[FORM_FORM_TYPE.TESTS]?.[FORM_SECTION_INNER_TYPE.IMPORT]}
        onCancel={handleFormModalClose}
        onFinish={handleFormTestsImportModalOk}
      />

      <Modal
        title={t('addFromLibrary')}
        open={formModalData[FORM_NAME.PLANS_TESTS_IMPORT_FROM_LIBRARY].visible}
        centered
        destroyOnClose
        onOk={handleOkTestImportFromLibrary}
        okText={t('add')}
        cancelText={t('cancel')}
        width={800}
        okButtonProps={{
          disabled: !formModalData[FORM_NAME.PLANS_TESTS_IMPORT_FROM_LIBRARY]?.item?.id
        }}
        onCancel={handleFormModalClose}
        forceRender
        className={'modal-restore'}
        styles={{
          body: {
            padding: 0
          }
        }}
      >
        <InnerTabs items={tabContentTestFromLibrary()} onTabClick={(key) => handleChangeTabTestFromLibrary(key)} />
      </Modal>

      <Modal
        title={t('testUserList')}
        open={formModalData[FORM_NAME.PLANS_TESTS_USER_LIST].visible}
        centered
        destroyOnClose
        onOk={handleOkTestUserList}
        okText={t('add')}
        cancelText={t('cancel')}
        width={400}
        onCancel={handleFormModalClose}
        forceRender
        className={'modal-restore'}
        styles={{
          body: {
            // padding: 0
          }
        }}
      >
        {testUserListContent}
      </Modal>
    </>
  )
}